module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.slotNodeLength > _vm.limitMoreButtons) ? _c('div', [_c('div', {
    staticClass: "detail-bill-return f-right detail-bill-white",
    class: {
      'active': _vm.extraBtnsShow
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.extraBtnsShow = !_vm.extraBtnsShow
      }
    }
  }, [_vm._v("更多")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-open-up"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.extraBtnsShow),
      expression: "extraBtnsShow"
    }],
    staticClass: "edi-extra-btn-container",
    on: {
      "click": _vm.hideExtraBtns
    }
  }, [_vm._t("buttons")], 2)])], 1) : _c('div', [_vm._t("buttons")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c630073a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MoreButtons.vue
// module id = 619
// module chunks = 1